import * as React from "react";
import Grid, { GridProps } from "@mui/material/Grid";
import { gridSpacing } from "./GridContainer";

const GridContainerItem = (
  props: GridProps & { xs?: number; sm?: number; md?: number; lg?: number },
) => {
  const { xs = 12, sm, md, lg, ...rest } = props;

  return (
    <Grid container size={{ xs, sm, md, lg }} spacing={gridSpacing} {...rest}>
      {props.children}
    </Grid>
  );
};

export default GridContainerItem;
